// @ts-nocheck
import { rfqQuoteDetailsInformationStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { GridItemStyle } from "@insite/mobius/GridItem";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(rfqQuoteDetailsInformationStyles, {
    ...rfqQuoteDetailsInformationStyles,
    detailsGridContainer: {
        gap: 20,
        css: css`
            margin-bottom: ${pxToRem(20)};
            // Valtech Custom Code -->
            @media print {
                ${GridItemStyle} {
                    padding-top: ${pxToRem(2)};
                    padding-bottom: ${pxToRem(2)};
                }
            }
            // Valtech Custom Code <--
        `,
    },
    expirationDateDatePicker: {
        cssOverrides: {
            datePicker: css`
                width: ${pxToRem(200)};
            `,
        },
    },
});
